import { Box, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import api from '../../service/api'
import { getCountString, Icons } from '../../utils/utilities'
import { Outlet, useSearchParams } from 'react-router-dom'
import TryAgainMessageBlock from '../../components/common/TryAgainMessageBlock'
import AuditPageHeader from '../../components/audit/AuditPageHeader'


const AuditDiscussions = () => {

    const [searchParams] = useSearchParams( { searchText: "", month: "", selectedInstitute: "all", view: "tabular", sortByName: "1", sortBySubmissionsCount: "1", sortByAssignmentCount: "1" } )
    const selectedInstitute = searchParams.get( 'selectedInstitute' ) || "all"

    const [error, setError] = useState( null )
    const [counts, setCounts] = useState( {} )
    const [loading, setLoading] = useState( true )

    const { layout } = useTheme()

    const getData = useCallback( async () => {
        try {
            setLoading( true )
            const { data: { data: counts } } = await api.audit.getDiscussionsCounts( { last30dayscount: true, institute: selectedInstitute !== "all" ? selectedInstitute : "" } )
            setCounts( counts )
            setError( null )
        } catch ( err ) {
            setError( { message: err?.response?.data?.message || "Something went wrong while fetching the discussions data.", code: err?.response?.code } )
        } finally {
            setLoading( false )
        }
    }, [selectedInstitute] )

    useEffect( () => {
        getData()
    }, [getData] )

    return (
        <Box padding={layout.pagePadding} display="flex" flexDirection="column" gap={layout.sectionsGap} overflow="auto" flexGrow={1}>

            <AuditPageHeader
                noDepartment
                loading={loading}
                title="Discussions audit"
                subtitle="View all discussions activities here."
                countCards={[
                    {
                        icon: Icons.default.Discussions,
                        label: "Discussions",
                        value: getCountString( counts.totalDiscussions ),
                        secondary: getCountString( counts.last30daysCount ),
                        secondaryLabel: "In last 30 days"
                    },
                    {
                        icon: Icons.default.Comment,
                        label: "Comments",
                        value: getCountString( counts.totalComments ),
                        secondary: getCountString( counts.last30daysCommentCount ),
                        secondaryLabel: "In last 30 days"
                    },
                ]}
            />

            {error && <Box sx={{ padding: "20px", flexShrink: 0 }}>
                <TryAgainMessageBlock getData={getData} err={error.message} code={error.code} loading={loading} />
            </Box>}
            <Outlet />
        </Box >
    )
}

export default AuditDiscussions
